import {useCallback, useEffect, useRef, useState} from "react";
import { useStore } from '@hmpu/powerups.store';
import { useVieConfig } from '@hmpu/powerups.vie.hooks.use-vie-config';
import { useTranslation } from '@hmpu/powerups.intl.hooks.use-translation';
import { useTranslate } from '@hmpu/powerups.intl.legacy.hooks.use-translate';
import { useSoundEffects } from '@hmpu/powerups.audio.hooks.use-sound-effects';
import Game from "./Game.jsx";

export const GamePlay = () => {

  const { __t } = useTranslation("GAME_PLAY");
  const translate = useTranslate();
  const { updateVieConfig } = useVieConfig();

  // const gameLevel = useStore((state) => state.gameLevel);
  // const gameCharacter = useStore((state) => state.gameCharacter) || 'skateboarder'; // TODO: add gameCharacter to game state slice
  // const levels = __t('levels', 'LEVEL_SELECTION');
  // const levels = __t('levels', 'GAME_PLAY');
  // const randomLevel = levels[Math.floor(Math.random() * levels.length)];
  // const glConfig = randomLevel;
  // console.log('glConfig: ', glConfig);
  // const gcConfig = __t('characters', 'CHARACTER_SELECTION').find(c => c.slug === gameCharacter);
  // console.log('game character config', gcConfig);

  const sfxUrlMap = translate('soundEffects', 'GAME_PLAY');
  const soundEffects = useRef(useSoundEffects({ urls: sfxUrlMap }));
  console.log('sfxUrlMap: ', sfxUrlMap);
  console.log('useSoundEffects({ urls: sfxUrlMap }: ', useSoundEffects({ urls: sfxUrlMap }));
  console.log('soundEffects: ', soundEffects);
  console.log('soundEffects.current.players: ', soundEffects.current.players);
  // useReactAudioContext
  // console.log(sfxUrlMap);
  // console.log(soundEffects.current);
  // debugger;

  // @2DO: This should be be array with metadata about the previous playthrough
  // const [playthroughs, setPlaythroughs] = useState(0);
  // const playthroughKey = useRef(0);
  // window.store2.playthroughs = 0;
  // const playthroughKey = window.store2.playthroughs; //  More accurately: .playthroughsUniterruptedWithThisLevel;

  // // initial load on mount
  // useEffect(() => {
  //   updateVieConfig({
  //     ...glConfig.vieConfig,
  //     overlays: (
  //       <span id="VIE-wrapper">
  //         <NitroGamePlay levelConfig={glConfig} charConfig={gcConfig} />
  //       </span>
  //     )
  //   });
  //   /* eslint-disable-next-line react-hooks/exhaustive-deps */
  // }, []);

  return <Game soundEffectsRef={soundEffects.current} />; // levelConfig={glConfig} />;
};

export default GamePlay;
